const localizationConstants = {
	login: 'login',
	register: 'register',
	emailAndUserName: 'emailAndUserName',
	passForgot: 'passForgot',
	usePasswordRecovery: 'usePasswordRecovery',
	verificationSuccessMsg: 'verificationSuccessMsg',
	verificationFailedMsg: 'verificationFailedMsg',
	registration: 'registration',
	registerConfirmationMessage: 'registerConfirmationMessage',
	termsOfUse: 'termsOfUse',
	andThe: 'and',
	privacyPolicy: 'privacyPolicy',
	alreadyAccount: 'alreadyAccount',
	noAccount: 'noAccount',
	copyShareLink: 'copyShareLink',
	sizeOfContest: 'sizeOfContest',
	close: 'close',
	copyLink: 'copyLink',
	pointSystem: 'pointSystem',
	entryFee: 'entryFee',
	prizeStructure: 'prizeStructure',
	multiEntry: 'multiEntry',
	multipleEntries: 'multipleEntries',
	contestName: 'contestName',
	visibility: 'visibility',
	private: 'private',
	public: 'public',
	next: 'next',
	back: 'back',
	confirmAndCreate: 'confirmAndCreate',
	chooseGames: 'chooseGames',
	selectAllGame: 'selectAllGame',
	chooseLeague: 'chooseLeague',
	settings: 'settings',
	contestSize: 'contestSize',
	chooseContestSize: 'chooseContestSize',
	chooseNumberOfWinners: 'chooseNumberOfWinners',
	chooseEntryFee: 'chooseEntryFee',
	numberOfEntries: 'numberOfEntries',
	beginner: 'beginner',
	beginnerDetails: 'beginnerDetails',
	tournament: 'tournament',
	tournaments: 'tournaments',
	tournamentDetails: 'tournamentDetails',
	h2h: 'h2h',
	h2hDetails: 'h2hDetails',
	multipliers: 'multipliers',
	multipliersDetails: 'multipliersDetails',
	fiftyFiftyDetails: 'fiftyFiftyDetails',
	createContest: 'createContest',
	rules: 'rules',
	ruleWinnerPick: 'ruleWinnerPick',
	ruleMaxPoint: 'ruleMaxPoint',
	ruleOnce: 'ruleOnce',
	ruleRemember: 'ruleRemember',
	scoring: 'scoring',
	highestValue: 'highestValue',
	lowestValue: 'lowestValue',
	confidenceValue: 'confidenceValue',
	games: 'games',
	entries: 'entries',
	winZone: 'winZone',
	rulesAndScoring: 'rulesAndScoring',
	lobby: 'lobby',
	inviteFriends: 'inviteFriends',
	language: 'language',
	logout: 'logout',
	plays: 'plays',
	contests: 'contests',
	wins: 'wins',
	winRate: 'winRate',
	profit: 'profit',
	uploadNewPhoto: 'uploadNewPhoto',
	getVerification: 'getVerification',
	verificationMsg: 'verificationMsg',
	verificate: 'verificate',
	save: 'save',
	changePassword: 'changePassword',
	userName: 'userName',
	firstName: 'firstName',
	lastName: 'lastName',
	country: 'country',
	dob: 'dob',
	oldPassword: 'oldPassword',
	newPassword: 'newPassword',
	confirmNewPassword: 'confirmNewPassword',
	email: 'email',
	password: 'password',
	cancel: 'cancel',
	upcoming: 'upcoming',
	inviteFriendsSubTitle: 'inviteFriendsSubTitle',
	inviteYourFriends: 'inviteYourFriends',
	shareInvitationLink: 'shareInvitationLink',
	friendRegister: 'friendRegister',
	friendRegisterAndDeposit: 'friendRegisterAndDeposit',
	challengeFriend: 'challengeFriend',
	takePart: 'takePart',
	inviteFriendsNow: 'inviteFriendsNow',
	contestType: 'contestType',
	sportsAndLeagues: 'sportsAndLeagues',
	byDate: 'byDate',
	byName: 'byName',
	clear: 'clear',
	searchContest: 'searchContest',
	noData: 'noData',
	fromToToDate: 'fromToToDate',
	join: 'join',
	update: 'update',
	noContest: 'noContest',
	arenaNoContest: 'arenaNoContest',
	createFirstContest: 'createFirstContest',
	arenaCreateFirstContest: 'arenaCreateFirstContest',
	filterResults: 'filterResults',
	clearAll: 'clearAll',
	live: 'live',
	history: 'history',
	myProfile: 'myProfile',
	contactUs: 'contactUs',
	faq: 'faq',
	howToPlay: 'howToPlay',
	switchToGerman: 'switchToGerman',
	switchToEnglish: 'switchToEnglish',
	balance: 'balance',
	deposit: 'deposit',
	Head_To_Head: 'headToHead',
	beginnerContest: 'beginnerContest',
	nextContestStarts: 'nextContestStarts',
	withdraw: 'withdraw',
	guaranteedPrize: 'guaranteedPrize',
	contestants: 'contestants',
	points: 'points',
	rank: 'rank',
	prize: 'prize',
	players: 'players',
	entrants: 'entrants',
	sport: 'sport',
	league: 'league',
	style: 'style',
	mode: 'mode',
	upcomingContests: 'upcomingContests',
	upcomingEntries: 'upcomingEntries',
	liveContests: 'liveContests',
	liveEntries: 'liveEntries',
	finishedContests: 'finishedContests',
	finishedEntries: 'finishedEntries',
	myContests: 'myContests',
	sort: 'sort',
	nextContestStart: 'nextContestStart',
	myAccount: 'myAccount',
	contactDetails: 'contactDetails',
	emailNotifications: 'emailNotifications',
	gameDayUpdates: 'gameDayUpdates',
	stippzPromotions: 'stippzPromotions',
	saveChanges: 'saveChanges',
	verificationMethod: 'verificationMethod',
	select: 'select',
	transactionHistory: 'transactionHistory',
	playerProtection: 'playerProtection',
	selfExclusion: 'selfExclusion',
	termOfUse: 'termOfUse',
	privacy: 'privacy',
	instantBankTransfer: 'instantBankTransfer',
	bankTransfer: 'bankTransfer',
	imprint: 'imprint',
	postCode: 'postCode',
	full: 'full',
	notRegister: 'notRegister',
	statusInfo: 'statusInfo',
	prizePool: 'prizePool',
	entryFeeInfo: 'entryFeeInfo',
	multiEntryInfo: 'multiEntryInfo',
	statusText: 'statusText',
	minimumAmount: 'minimumAmount',
	myWinnings: 'myWinnings',
	requiredFieldValidation: 'requiredFieldValidation',
	countryR: 'countryR',
	date: 'date',
	passwordValidation: 'passwordValidation',
	minValueValidation: 'minValueValidation',
	maxValueValidation: 'maxValueValidation',
	noSpaceValidation: 'noSpaceValidation',
	onlyNumbersValidation: 'onlyNumbersValidation',
	notValid: 'notValid',
	manualDeposit: 'manualDeposit',
	topUp: 'topUp',
	recipient: 'recipient',
	paymentPurpose: 'paymentPurpose',
	savedBank: 'savedBank',
	addNew: 'addNew',
	noSavedAccount: 'noSavedAccount',
	lobbyDate: 'lobbyDate',
	lobbyPrize: 'lobbyPrize',
	processingTime: 'processingTime',
	onlyNumbersWithNotAllowedZeroAtFirstPosition: 'onlyNumbersWithNotAllowedZeroAtFirstPosition',
	verificationSuccess: 'verificationSuccess',
	contactUsSubmit: 'contactUsSubmit',
	oldPasswordMatch: 'oldPasswordMatch',
	payOutFee: 'payOutFee',
	minimumAmount5: 'minimumAmount5',
	declined: 'declined',
	needsReview: 'needsReview',
	confirm: 'confirm',
	publicContest: 'publicContest',
	privateContest: 'privateContest',
	setting: 'setting',
	menu: 'menu',
	withdrawLimit: 'withdrawLimit',
	notEnoughMatches: 'notEnoughMatches',
	newEntry: 'newEntry',
	existingEntry: 'existingEntry',
	minimumUserNameValidation: 'minimumUserNameValidation',
	verificationDone: 'verificationDone',
	verificationFailed: 'verificationFailed',
	returnLogin: 'returnLogin',
	makeYourPicks: 'makeYourPicks',
	chooseConfidencePoints: 'chooseConfidencePoints',
	pts: 'pts',
	confidence: 'confidence',
	odds: 'odds',
	place: 'place',
	guaranteed: 'guaranteed',
	invitationCompetition: 'invitationCompetition',
	competitionName: 'competitionName',
	finished: 'finished',
	myPrize: 'myPrize',
	copied: 'copied',
	prizePoolTitle: 'prizePoolTitle',
	forFee: 'forFee',
	free: 'free',
	position: 'position',
	copyClipboard: 'copyClipboard',
	failCopy: 'failCopy',
	pleaseWait: 'pleaseWait',
	yourBalance: 'yourBalance',
	amount: 'amount',
	id: 'id',
	liveRank: 'liveRank',
	livePrize: 'livePrize',
	iBan: 'iBan',
	sendEmail: 'sendEmail',
	emailDetails: 'emailDetails',
	done: 'done',
	inProgress: 'inProgress',
	confirmPassword: 'confirmPassword',
	passWordMustMatch: 'passWordMustMatch',
	lowercaseValidation: 'lowercaseValidation',
	trimValidation: 'trimValidation',
	customEmailValidation: 'customEmailValidation',
	customPasswordMessageValidation: 'customPasswordMessageValidation',
	minLengthValidation: 'minLengthValidation',
	maxLengthValidation: 'maxLengthValidation',
	ownerName: 'ownerName',
	bankName: 'bankName',
	finishedGames: 'finishedGames',
	yourPicks: 'yourPicks',
	noGames: 'noGames',
	started: 'started',
	youCanCreateFirstContest: 'youCanCreateFirstContest',
	arena: 'arena',
	joined: 'joined',
	guaranteedPrizepool: 'guaranteedPrizepool',
	prizeMoney: 'prizeMoney',
	OPEN: 'OPEN',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	standings: 'standings',
	fiftyFifty: 'fiftyFifty',
	chooseMode: 'chooseMode',
	chooseType: 'chooseType',
	soccer: 'soccer',
	basketball: 'basketball',
	americanFootball: 'football',
	hockey: 'hockey',
	baseball: 'baseball',
	allSports: 'allSports',
	passwordRecoveryMessage: 'passwordRecoveryMessage',
	passwordRecovery: 'passwordRecovery',
	checkEmail: 'checkEmail',
	sendRecoveryLinkMessage: 'sendRecoveryLinkMessage',
	enterNewPassword: 'enterNewPassword',
	sendRecoveryLink: 'sendRecoveryLink',
	winnerTakesItAll: 'winnerTakesItAll',
	top2Win: 'top2Win',
	top3Win: 'top3Win',
	top5Win: 'top5Win',
	top10Win: 'top10Win',
	top15Win: 'top15Win',
	top20Win: 'top20Win',
	top25Win: 'top25Win',
	top30Win: 'top30Win',
	top40Win: 'top40Win',
	top50Win: 'top50Win',
	top60Win: 'top60Win',
	top75Win: 'top75Win',
	top100Win: 'top100Win',
	top150Win: 'top150Win',
	top200Win: 'top200Win',
	top300Win: 'top300Win',
	top400Win: 'top400Win',
	top800Win: 'top800Win',
	top1200Win: 'top1200Win',
	top1600Win: 'top1600Win',
	top2000Win: 'top2000Win',
	top2500Win: 'top2500Win',
	top3000Win: 'top3000Win',
	top3300Win: 'top3300Win',
	top4000Win: 'top4000Win',
	top5000Win: 'top5000Win',
	top6000Win: 'top6000Win',
	welcomeBonus: 'welcomeBonus',
	referenceBonus: 'referenceBonus',
	referralBonus: 'referralBonus',
	depositFail: 'depositFail',
	payout: 'payout',
	contestJoinCharge: 'contestJoinCharge',
	contestCancelledRefund: 'contestCancelledRefund',
	contestWinAmount: 'contestWinAmount',
	contestCommissionBooked: 'contestCommissionBooked',
	draw: 'draw',
	chooseSport: 'chooseSport',
	signUpEmailMsg: 'signUpEmailMsg',
	joiningMsg: 'joiningMsg',
	wlsignUpEmailMsg: 'wlsignUpEmailMsg',
	halfTime: 'halfTime',
	fullTime: 'fullTime',
	ibanValidation: 'ibanValidation',
	amountValidation: 'amountValidation',
	error404: 'error404',
	message404: 'message404',
	homeButtonText: 'homeButtonText',
	error503: 'error503',
	message503: 'message503',
	contestSearchErrorMsg: 'contestSearchErrorMsg',
	withDrawNote: 'withDrawNote',
	contest1: 'contest1',
	contest1_1: 'contest1_1',
	contest1_2: 'contest1_2',
	contest1_writer: 'contest1_writer',
	contest2: 'contest2',
	contest2_1: 'contest2_1',
	contest2_2: 'contest2_2',
	contest2_writer: 'contest2_writer',
	contest3: 'contest3',
	contest3_1: 'contest3_1',
	contest3_2: 'contest3_2',
	contest3_writer: 'contest3_writer',
	contest4: 'contest4',
	contest4_1: 'contest4_1',
	contest4_2: 'contest4_2',
	contest4_writer: 'contest4_writer',
	contest5: 'contest5',
	contest5_1: 'contest5_1',
	contest5_writer: 'contest5_writer',
	contest7_1: 'contest7_1',
	contest7_2: 'contest7_2',
	contest7_3: 'contest7_3',
	contest7_4: 'contest7_4',
	contest8: 'contest8',
	contest9: 'contest9',
	contest10: 'contest10',
	contest11: 'contest11',
	contest12: 'contest12',
	contest13: 'contest13',
	contest12_1: 'contest12_1',
	contest8_1: 'contest8_1',
	contest9_1: 'contest9_1',
	contest10_1: 'contest10_1',
	contest13_1: 'contest13_1',
	contest13_2: 'contest13_2',
	joinedStatusTag: 'joinedStatusTag',
	cancelled: 'cancelled',
	filters: 'filters',
	filter: 'filter',
	walletHistory: 'walletHistory',
	registrationPolicy: 'registrationPolicy',
	of: 'of',
	seireATitle_1: 'seireATitle_1',
	seireATitle_2: 'seireATitle_2',
	seireATitle_3: 'seireATitle_3',
	serieASubTitle_1: 'serieASubTitle_1',
	serieASubTitle_2: 'serieASubTitle_2',
	bundesLigaTitle_1: 'bundesLigaTitle_1',
	bundesLigaTitle_2: 'bundesLigaTitle_2',
	bundesLigaTitle_3: 'bundesLigaTitle_3',
	bundesLigaSubTitle_1: 'bundesLigaSubTitle_1',
	bundesLigaSubTitle_2: 'bundesLigaSubTitle_2',
	laLigaTitle_1: 'laLigaTitle_1',
	laLigaTitle_2: 'laLigaTitle_2',
	laLigaTitle_3: 'laLigaTitle_3',
	laLigaSubTitle_1: 'laLigaSubTitle_1',
	laLigaSubTitle_2: 'laLigaSubTitle_2',
	mixedTitle_1: 'mixedTitle_1',
	mixedTitle_2: 'mixedTitle_2',
	mixedTitle_3: 'mixedTitle_3',
	mixedSubTitle_1: 'mixedSubTitle_1',
	mixedSubTitle_2: 'mixedSubTitle_2',
	premierTitle_1: 'premierTitle_1',
	premierTitle_2: 'premierTitle_2',
	premierTitle_3: 'premierTitle_3',
	premierSubTitle_1: 'premierSubTitle_1',
	premierSubTitle_2: 'premierSubTitle_2',
	week: 'week',
	iOSInstall: 'iOSInstall',
	verificationMessage: 'verificationMessage',
	continue: 'continue',
	uefaEuropeanTitle_1: 'uefaEuropeanTitle_1',
	uefaEuropeanTitle_2: 'uefaEuropeanTitle_2',
	uefaEuropeanSubTitle_1: 'uefaEuropeanSubTitle_1',
	uefaEuropeanSubTitle_2: 'uefaEuropeanSubTitle_2',
	statistics: 'statistics',
	discord: 'discord',
	minContestantRequired: 'minContestantRequired',
	boostInfo: 'boostInfo',
	win: 'win',
	winsOrDraw: 'winsOrDraw',
	winsWith: 'winsWith',
	goals: 'goals',
	rewards: 'rewards',
	withDrawHistory: 'withDrawHistory',
	winsBy: 'winsBy',
	goalsDifference: 'goalsDifference',
	winsOrLosesByMax: 'winsOrLosesByMax',
	pointDifference: 'pointDifference',
	news: 'news',
	fanshop: 'fanshop',
	tickets: 'tickets',
	riskRewardMode: 'riskRewardMode',
	inRiskReward: 'inRiskReward',
	boostHomeWinDrawAwayWin: 'boostHomeWinDrawAwayWin',
	boostHomeWinAwayWin: 'boostHomeWinAwayWin',
	and: 'and',
	pointsRule: 'pointsRule',
	boost: 'boost',
	safety: 'safety',
	boostRule: 'boostRule',
	footBallBoostRule: 'footBallBoostRule',
	basketBallBoostRule: 'basketBallBoostRule',
	safetyRule: 'safetyRule',
	footBallSafetyRule: 'footBallSafetyRule',
	basketBallSafetyRule: 'basketBallSafetyRule',
	note: 'note',
	pointsPublication: 'pointsPublication',
	savePicksReminder: 'savePicksReminder',
	rulesForBoostAndSafety: 'rulesForBoostAndSafety',
	strategicAdjust: 'strategicAdjust',
	picksChangeInfo: 'picksChangeInfo',
	planBets: 'planBets',
	tieRules: 'tieRules',
	tieRulesDescription: 'tieRulesDescription',
	contestResultMessage: 'contestResultMessage',
	contestWinZoneResultMessage: 'contestWinZoneResultMessage',
	tipOff: 'tipOff',
	whiteLabelIOSInstall: 'whiteLabelIOSInstall',
	oddsNotAvailable: 'oddsNotAvailable',
	wlNoContest: 'wlNoContest',
	wlJoinContest: 'wlJoinContest',
	sideBarWins: 'sideBarWins',
	gotIt: 'gotIt',
	contestFull: 'contestFull',
	joinAnotherContest: 'joinAnotherContest',
	goToHome: 'goToHome',
	viewUpdates: 'viewUpdates',
	versionUpgrade: 'versionUpgrade',
	updateAvailableMsg: 'updateAvailableMsg',
	refreshMsg: 'refreshMsg'
};

export default localizationConstants;
